import React, {useContext, useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import styled, {useTheme} from "styled-components";
import {LanguageContext} from "../../provider/language";
import {RootContext} from "../../with-root";
import {Link} from "gatsby";
import {AssetContext} from "../../provider/asset";

const Container = styled.header`
  position: relative;
`;

const Img = styled.img<{centered?: boolean}>`
  height: 80px;
  margin: auto;
  margin-top: ${({centered}) => centered && "40px"};
`;

const CenteredImageWrapper = styled.div`
  height: 150px;
`;

const LangSelection = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const LanguageSwitcher = styled.div`
  position: absolute;
  top: 4px;
  right: 8px;
`;

const LogoWrapper = styled.div`
  margin-top: 60px;
  margin-bottom: 40px;
`;

const Horizontal = styled.div`
  width: 1px;
  border-left: 1px solid white;
  height: 60px;
  margin: 5px 24px 0 24px;
`;

const Stamp40Small = styled.p`
  opacity: ${(props) => props.theme.opacity};
  text-align: center;
  text-transform: uppercase;
  font-size: 8px;
  letter-spacing: ${(props) => props.theme.letterSpacing};
  margin: 5px 0;
  padding-top: 5px;
`;

const Stamp40Large = styled.span`
  text-transform: uppercase;
  letter-spacing: ${(props) => props.theme.letterSpacing};
`;

const Header = () => {
  // Block SSR, only use client side rendering, since we depend on the AssetContext.
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  if (!hydrated) return null;

  const intl = useIntl();
  const theme = useTheme();
  const {location} = useContext(RootContext);
  const {languages, setLocale} = useContext(LanguageContext);
  const {isSwissPost} = useContext(AssetContext);

  const pathname = location?.pathname ?? "/"; // fallback for SSR

  const localeLinks = languages.map((language, idx, arr) => {
    const link = (
      <a
        href={pathname}
        style={{color: theme.fontColor}}
        onClick={(e) => {
          e.preventDefault();
          setLocale(language.locale);
        }}
      >
        {language.locale.toUpperCase()}
      </a>
    );
    const spacer = idx === arr.length - 1 ? "" : "|";
    return (
      <span key={idx}>
        <span className="mx-2">{link}</span>
        {spacer}
      </span>
    );
  });

  const logoSrc = isSwissPost ? "/logo/post_swiss.svg" : "/logo/philatelie_logo_weiss.svg";
  const logoAlt = intl.formatMessage({id: isSwissPost ?  "logo.post_swiss.alt": "logo.philatelie.alt"});
  const logoLink = isSwissPost ? "https://www.post.ch" : "/";
  console.info(`Header: isSwissPost=${isSwissPost}`); // TODO remove debug messages after test

  return (
    <Container className="container">
      <div className="d-block d-md-none">
        <Stamp40Small className="d-block d-md-none">
          <FormattedMessage id="header.stamp.4.0" />
        </Stamp40Small>
        <LanguageSwitcher>{localeLinks}</LanguageSwitcher>
      </div>
      <LangSelection className="d-none d-md-flex">
        <Stamp40Large className="text-uppercase">
          <FormattedMessage id="header.stamp.4.0" />
        </Stamp40Large>
        <Horizontal />
        <div>{localeLinks}</div>
      </LangSelection>
      <div className="row">
        <div className="col-12 d-md-none text-center">
          {isSwissPost ? (
            <a href={logoLink} target="_blank" rel="noopener noreferrer">
              <CenteredImageWrapper>
                <Img centered src={logoSrc} alt={logoAlt} />
              </CenteredImageWrapper>
            </a>
          ) : (
            <Link to={logoLink}>
              <CenteredImageWrapper>
                <Img centered src={logoSrc} alt={logoAlt} />
              </CenteredImageWrapper>
            </Link>
          )}
        </div>
        <div className="d-none d-sm-none d-md-block col-md-4">
          {isSwissPost ? (
            <a href={logoLink} target="_blank" rel="noopener noreferrer">
              <LogoWrapper>
                <Img src={logoSrc} alt={logoAlt} />
              </LogoWrapper>
            </a>
          ) : (
            <Link to={logoLink}>
              <LogoWrapper>
                <Img src={logoSrc} alt={logoAlt} />
              </LogoWrapper>
            </Link>
          )}
        </div>
      </div>
    </Container>
  );
};

export default Header;
